import environment from '../environment';
import StoresControl from './StoresControl';

export class StoresMotocycleControl extends StoresControl {
    constructor() {
        const options = {
            name: 'StoresMotocycle',
            context: 'LAYER_STORES_MOTOCYCLE',
        };

        super(options);
    }

    static getInstance() {
        if (!StoresMotocycleControl._instance) {
            StoresMotocycleControl._instance = new StoresMotocycleControl();
        }

        return StoresMotocycleControl._instance;
    }
}

export default StoresMotocycleControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/StoresMotocycleControl.js